import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, ViewChild, AfterViewInit
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {AgmMap} from '@agm/core';

@Component({
  selector: 'app-visit',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'visit.template.html',
  styleUrls: [
    './visit.style.scss'
  ]
})
export class VisitComponent  implements OnInit, AfterViewInit  {
  context: CanvasRenderingContext2D;

  @ViewChild('painCanvas', {static: false}) painCanvas;

  public form: FormGroup;
  public complaintProfile: any = {coordinates: []};
  public complaints: any[];

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<VisitComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public ngOnInit(): void {
    (this.data.complaints || []).map( complaint => {
      if ( complaint.image) {
        this.complaintProfile.image = complaint.image;
        this.complaintProfile.width = complaint.width || this.complaintProfile.width;
        this.complaintProfile.height = complaint.height || this.complaintProfile.height;
        this.complaintProfile.level = complaint.level || this.complaintProfile.level;
        if ( complaint.coordinate ) {
          this.complaintProfile.coordinates.push( complaint.coordinate);
        }
      }
    });
    this.complaints = (this.data.complaints || []).filter(complaint => complaint.detail);
  }

  ngAfterViewInit() {
    const canvas = this.painCanvas.nativeElement;
    this.context = canvas.getContext('2d');

    if ( this.complaintProfile.image ) {
      const image = new Image();
      image.src = `/assets/${this.complaintProfile.image}.svg`;
      image.width = this.complaintProfile.width;
      image.height = this.complaintProfile.height;
      canvas.width = image.width;
      canvas.height = image.height;
      image.onload = () => {
        const ctx = this.context;
        ctx.clearRect(0, 0, image.width, image.height);
        ctx.drawImage(image, 0, 0);

        ctx.fillStyle = 'rgba(204, 34, 34, 0.6)';
        ctx.strokeStyle = 'rgba(204, 34, 34, 0.6)';
        //const scale = image.width / this.data.painDiagram.width;
        //console.log("Scale " + scale);
        for (const coordinate of this.complaintProfile.coordinates) {
          ctx.beginPath();
          ctx.arc((coordinate.x * 1.0), (coordinate.y * 1.0), 10, 0, 2 * Math.PI);
          ctx.fill();
          ctx.stroke();
        }
      };
    }
  }

}
